import {
  CentralSystemDetailSlideIn,
  CentralSystemOverviewTab,
  CentralSystemsPage
} from '@infuse/e-connector/central-system/pages';
import { InfusePageView } from '@infuse/ui/layouts';
import { AppRouter } from '@infuse/ui/router';
import { Plugin } from 'vue';
import { centralSystemPermissions } from '@infuse/api/e-connector/central-system';

export const CentralSystemFeaturePlugin: Plugin = {
  install() {
    AppRouter.addRoute('main', {
      path: '/central-systems',
      component: InfusePageView,
      meta: {
        name: 'nav.centralSystems',
        icon: 'operators',
        group: 'nav.nav-group.manage',
        permissionIds: [centralSystemPermissions.SEARCH]
      },
      children: [
        {
          path: '',
          name: 'central-systems',
          component: CentralSystemsPage
        },
        {
          path: ':id',
          components: {
            default: CentralSystemsPage,
            slideIn: CentralSystemDetailSlideIn
          },
          children: [
            {
              path: '',
              redirect: {
                name: 'central-systems.overview'
              }
            },
            {
              path: 'overview',
              name: 'central-systems.overview',
              component: CentralSystemOverviewTab,
              meta: {
                type: 'tab',
                label: 'tabs.centralSystems.overview',
                permissionIds: [centralSystemPermissions.GET]
              }
            }
          ]
        }
      ]
    });
  }
};
